import React, { useState, useEffect } from 'react';
import AnimateOnScroll from './../animate';
import { Link, useLocation } from "react-router-dom";


const Header = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const isActive = (path) => currentPath === path ? "nav-item active" : "nav-item";

const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNavbar = () => {
    setIsNavOpen(!isNavOpen);
  };

  const closeMenus = () => {
    setIsNavOpen(false)
  }

	  useEffect(() => {

	  }, []);
		
		return (
			<>
  <nav className="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light" id="ftco-navbar">
    <div className="container">
        <Link className="navbar-brand" to="/">
      {/* <span className="flaticon-lotus"></span> */}
      <img src="images/Logo_salon.svg" alt="Divine Blush Beauty Logo"></img>
       Divine Blush Beauty
    </Link>
      <button className="navbar-toggler"  onClick={toggleNavbar} type="button" data-toggle="collapse" data-target="#ftco-nav" aria-controls="ftco-nav"         aria-expanded={isNavOpen}
 aria-label="Toggle navigation">
        <span className="oi oi-menu" /> Menu
      </button>
      <div className={`collapse navbar-collapse ${isNavOpen ? 'show' : ''}`} id="ftco-nav">
     <ul className="navbar-nav ml-auto">
      <li className={isActive("/")} onClick={closeMenus}>
        <Link to="/" className="nav-link">Home</Link>
      </li>
      <li className={isActive("/about")} onClick={closeMenus}>
        <Link to="/about" className="nav-link">About</Link>
      </li>
      <li className={isActive("/book-appointment")} onClick={closeMenus}>
        <Link to="/book-appointment" className="nav-link">Appointment</Link>
      </li>
      <li className={isActive("/pricing")} onClick={closeMenus}>
        <Link to="/pricing" className="nav-link">Pricing</Link>
      </li>
      <li className={isActive("/reviews")} onClick={closeMenus}>
        <Link to="/reviews" className="nav-link">Reviews</Link>
      </li>
      <li className={isActive("/contact")} onClick={closeMenus}>
        <Link to="/contact" className="nav-link">Contact</Link>
      </li>
    </ul>
      </div>
    </div>
  </nav>
       </>
		  );

	
	  }	
	  export default Header;
// }	
// function mapStateToProps(state) {
// 	// console.log(state)
// 	 const userData = state.authReducer.user;
// 	 return { userData };
//    }
//    export default connect(mapStateToProps)(Header);